export default {
      id: "tile-single-entry-usage",
      viewBox: "0 0 45 34",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#tile-single-entry",
      toString: function () {
        return this.url;
      }
    }